__turbopack_context__.v({
  "col": "lead-form-module-scss-module__5GePtq__col",
  "content": "lead-form-module-scss-module__5GePtq__content",
  "error": "lead-form-module-scss-module__5GePtq__error",
  "form": "lead-form-module-scss-module__5GePtq__form",
  "placeholder": "lead-form-module-scss-module__5GePtq__placeholder",
  "section": "lead-form-module-scss-module__5GePtq__section",
});
